.box {
    display: inline-block;
    white-space: nowrap;
    .renderer {
        display: inline-block;
        vertical-align: middle;
        width: 1rem;
        height: 1rem;
        border: 1px solid;
        margin-right: 0.5rem;
    }
}
